enum OrderViewMode {
  Fulfillment,
  Pharmacy,
}
export default OrderViewMode
